// types
import type { AdditionalSelectors } from '../types/AdditionalSelectors';
import type { HostActions } from './hostActions';

// store
import * as actionCreators from './actionCreators';
import { MiddlewareManager } from './middlewareManager';
import { Selectors } from './selectors';

export const roleAssumptionCreators = actionCreators;
export let roleAssumptionSelectors: Selectors;
export let middlewareMgr: MiddlewareManager;

export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors,
    hostActions?: HostActions
): {
    selectors: Selectors;
    middlewareMgr: MiddlewareManager;
} => {
    roleAssumptionSelectors = new Selectors(appName, additionalSelectors);
    middlewareMgr = new MiddlewareManager(roleAssumptionSelectors, hostActions);

    return {
        selectors: roleAssumptionSelectors,
        middlewareMgr
    };
};
